import { Label } from '../../../components/ui/label';
import { Input } from '../../../components/ui/input';
import MultiSelectDropdownNoCreate from '../../dropdowns/MultiSelectDropdownNoCreate';
import { QRCodeConfigurationTabProps } from './types';

export default function QRCodeConfiguration(props: QRCodeConfigurationTabProps) {
  const {
    formData,
    updateFormData,

    availableForms,
    handleFieldFocus,
    isFieldInvalid,
    invalidFields,
    setInvalidFields,
  } = props;

  const { elementName, redirectType, connectedForms, customUrl } = formData;

  return (
    <>
      {/* Element Name */}
      <div className="space-y-0">
        <Label
          htmlFor="element-name"
          className="font-inter text-base font-medium leading-6 text-ink-secondary"
        >
          Element Name
        </Label>
        <Input
          id="element-name"
          value={elementName}
          onChange={(e) => {
            updateFormData('elementName', e.target.value);
          }}
          onFocus={() => handleFieldFocus('configuration-elementName')}
          className={`h-[28px] flex-shrink-0 self-stretch ${
            isFieldInvalid('elementName') ? 'border-red-500' : ''
          }`}
        />
      </div>

      {/* Redirect Type */}
      <div className="space-y-1">
        <Label className="font-inter text-base font-medium leading-6 text-ink-secondary">
          Redirect Type
        </Label>
        <div className="flex gap-6">
          <button
            type="button"
            className="flex items-center gap-1"
            onClick={() => {
              updateFormData('redirectType', 'HOSTED_PAGE');
              handleFieldFocus('configuration-redirectType');
            }}
          >
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 bg-white ${
                isFieldInvalid('redirectType')
                  ? 'border-red-500'
                  : redirectType === 'HOSTED_PAGE' ? 'border-sage' : 'border-edge'
              }`}
              aria-hidden
            >
              {redirectType === 'HOSTED_PAGE' && (
                <span className="h-2 w-2 rounded-full bg-sage" />
              )}
            </span>
            <Label className="text-sm font-normal text-ink-secondary">
              Hosted Page
            </Label>
          </button>
          <button
            type="button"
            className="flex items-center gap-1"
            onClick={() => {
              updateFormData('redirectType', 'CUSTOM_PAGE');
              handleFieldFocus('configuration-redirectType');
            }}
          >
            <span
              className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border-2 bg-white ${
                isFieldInvalid('redirectType')
                  ? 'border-red-500'
                  : redirectType === 'CUSTOM_PAGE' ? 'border-sage' : 'border-edge'
              }`}
              aria-hidden
            >
              {redirectType === 'CUSTOM_PAGE' && (
                <span className="h-2 w-2 rounded-full bg-sage" />
              )}
            </span>
            <Label className="text-sm font-normal text-ink-secondary">
              Custom Link
            </Label>
          </button>
        </div>
      </div>

      {/* Conditional: Show Form dropdown when Hosted Page is selected */}
      {redirectType === 'HOSTED_PAGE' && (
        <div className="space-y-0">
          <Label className="font-inter text-base font-medium leading-6 text-ink-secondary">Form</Label>
          <div>
            <MultiSelectDropdownNoCreate
              height={28}
              options={(availableForms || [])
                .sort((a, b) => a.formName.localeCompare(b.formName))
                .map((form) => ({
                  value: form.formName,
                  label: form.formName,
                }))}
              setItems={(items) => {
                // Only allow single selection for QR code
                updateFormData('connectedForms', items[0] ? [items[0]] : []);
                updateFormData(
                  'formIDs',
                  items[0]
                    ? [availableForms.find((form) => form.formName === items[0])?.formID || '']
                    : [],
                );
                handleFieldFocus('configuration-connectedForms');
              }}
              items={connectedForms && connectedForms.length > 0 ? [connectedForms[0]] : []}
              error={Boolean(isFieldInvalid('configuration-connectedForms'))}
            />
          </div>
        </div>
      )}

      {/* Conditional: Show URL input when Custom Link is selected */}
      {redirectType === 'CUSTOM_PAGE' && (
        <div className="space-y-0">
          <Label
            htmlFor="url-for-qr"
            className="font-inter text-base font-medium leading-6 text-ink-secondary"
          >
            URL
          </Label>
          <Input
            id="url-for-qr"
            value={customUrl}
            onChange={(e) => {
              updateFormData('customUrl', e.target.value);
            }}
            onFocus={() => handleFieldFocus('configuration-customUrl')}
            className={`h-[28px] flex-shrink-0 self-stretch ${
              isFieldInvalid('customUrl') ? 'border-red-500' : ''
            }`}
            placeholder="https://example.com"
          />
        </div>
      )}
    </>
  );
}
